import './IssueLabelToken-9a01c394.css';

var classes = {"IssueLabel":"prc-Token-IssueLabel-ZuoEW","RemoveButton":"prc-Token-RemoveButton-H4Dmg"};

export { classes as default };
